import React, { useState, useEffect } from "react";
import { Maximize, UploadCloud, Expand } from "lucide-react";
import DocumentPreview from "../../Create-Investment/documentpreview";
import { useDispatch, useSelector } from "react-redux";
import { clearCurrentStep } from "../../../Redux/store/onboardingFormSlice";
import { useNavigate, useLocation } from "react-router-dom";
import { useToast } from "../../../Utils/toastContext";

const ReviewSubmit = ({ setCurrentStep }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const customerId = useSelector((state) => state.form.onboardingCustomer);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const stepStatus = useSelector((state) => state.form.stepStatus);
  const isInvitee = useSelector((state) => state.user.isInvitee);
  const [loading, setLoading] = useState(false);
  const formData = useSelector((state) => state.form.formData);
  const [firstName, setFirstName] = useState("");
  const [profilePic, setProfilePic] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [otherActivity, setOtherActivity] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [customerType, setCustomerType] = useState("");
  const [advisorRefNumber, setAdvisorRefNumber] = useState(
    "99834 (Brian	Vaughan)"
  );
  const [typeOfAccount, setTypeOfAccount] = useState("");
  const [fullName, setFullName] = useState("");
  const [formerNames, setFormerNames] = useState("");
  const [dob, setDob] = useState("");
  const [redAddress, setRedAddress] = useState("");
  const [ownership, setOwnership] = useState("");

  const [applicantCountryText, setApplicantCountryText] = useState("");
  const [clientNo, setClientNo] = useState("CM0013189P");
  const [jointAccountID, setJointAccountID] = useState("");
  const [expectedAmount, setExpectedAmount] = useState("");
  const [investmentCurrency, setInvestmentCurrency] = useState("");
  const [signatory, setSignatory] = useState("yes");
  const [thirdPartySign, setThirdPartySign] = useState("yes");
  const [jointAccountName, setJointAccountName] = useState("");
  const [fileAttorney, setFileAttorney] = useState(null);
  const [taxResidentCountry, setTaxResidentCountry] = useState(1);
  const [taxResidentCountryText, setTaxResidentCountryText] = useState("US");
  const [businessNature, setBusinessNature] = useState(null);
  const [businessNatureText, setBusinessNatureText] = useState("");
  const [nonResCountry, setNonResCountry] = useState(null);
  const [nonResCountryText, setNonResCountryText] = useState("");
  const [socialSecurityNumber, setSocialSecurityNumber] = useState("");
  const [taxId, setTaxId] = useState("");
  const [abn, setAbn] = useState("");
  const [businessRegistrationNumber, setBusinessRegistrationNumber] =
    useState("");
  const [businessAddress, setBusinessAddress] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [businessActivity, setBusinessActivity] = useState("smaple text");
  const [businessActivityText, setBusinessActivityText] =
    useState("smaple text");
  const [fundSource, setFundSource] = useState("");
  const [transactionNature, setTransactionNature] = useState("");
  const [caprockFund, setCaprockFund] = useState("smaple text");
  const [image, setImage] = useState("/avatar.svg");
  const [fullscreen, setFullscreen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isConfirmWithdraw, setIsConfirmWithdraw] = useState(false);
  const [currentDocument, setcurrentDocument] = useState({});
  const [fileThirdParty, setFileThirdParty] = useState(null);
  const [description, setDescription] = useState("");
  const [fileProof, setFileProof] = useState(null);
  const [jointAccountMembers, setJointAccountMembers] = useState([]);
  const [applicantCountry, setApplicantCountry] = useState(null);
  const [filePurpose, setFilePurpose] = useState("");
  const [accountPurpose, setAccountPurpose] = useState("");
  const [accountType, setAccountType] = useState(null);
  const [documentNumberSecond, setDocumentNumberSecond] = useState("");

  const secondheaders = [
    "",
    "First Name",
    "Last Name",
    "Date Of Birth",
    "Email Address",
    "Mobile Number",
    "Account Type",
  ];
  const secondheadersWithAddress = [
    "",
    "First Name",
    "Last Name",
    "Date Of Birth",
    "Email Address",
    "Mobile Number",
    "Residential Address",
    "Account Type",
  ];
  const [bankdata, setBankdata] = useState([]);
  const [accountCount, setAccountCount] = useState(7);
  const [photoIdText, setPhotoIdText] = useState("");
  const [nonphotoIdText, setNonPhotoIdText] = useState("");
  const [nonphotoId, setNonPhotoId] = useState(null);
  const [photoId, setphotoId] = useState(1);
  const [filePhotographicId, setFilePhotographicId] = useState(null);
  const [fileDriverLinsenceFront, setFileDriverLinsenceFront] = useState(null);
  const [fileDriverLinsenceBack, setFileDriverLinsenceBack] = useState(null);
  const [expiryDate, setExpiryDate] = useState("02/12/2026");
  const [expiryDateSecond, setExpiryDateSecond] = useState("");
  const [photoIdFirst, setphotoIdFirst] = useState(1);
  const [photoIdFirstText, setphotoIdFirstText] = useState("");
  const [photoIdSecondText, setphotoIdSecondText] = useState("");
  const [photoIdSecond, setphotoIdSecond] = useState(2);
  const [documentNumber, setDocumentNumber] = useState("");

  const [filePhotographicIdFirst, setfilePhotographicIdFirst] = useState(null);
  const [fileDriverLinsenceFrontFirst, setFileDriverLinsenceFrontFirst] =
    useState(null);
  const [fileDriverLinsenceBackFirst, setFileDriverLinsenceBackFirst] =
    useState(null);
  const [fileDriverLinsenceBackSecond, setFileDriverLinsenceBackSecond] =
    useState(null);
  const [filePhotographicIdSecond, setfilePhotographicIdSecond] =
    useState(null);
  const [fileDriverLinsenceFrontSecond, setFileDriverLinsenceFrontSecond] =
    useState(null);
  const [fileNonPhotographicId, setfileNonPhotographicId] = useState(null);
  const [personalDataId, setPersonalDataId] = useState(1);
  const [personalDataIdText, setPersonalDataIdText] = useState("");
  const [fileCV, setFileCV] = useState(null);
  const [webLink, setWebLink] = useState("");
  const [accounts, setAccounts] = useState([]);
  const handleFileClick = (docData) => {
    setcurrentDocument(docData);
    setIsModalOpen(true);
  };

  useEffect(() => {
    if (formData) {
      //  setReviewFields();
      dispatch(clearCurrentStep());
    }
  }, [formData]);
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const getDetails = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/advisor/onboarding/verification/customer/${customerId}/preview`
      );

      if (response.status == 200) {
        //SignUp details
        setFirstName(response.data.open_account_information.first_name);
        setLastName(response.data.open_account_information.last_name);
        setEmail(response.data.open_account_information.email_address);
        setMobileNumber(
          response.data.open_account_information.country_code +
            response.data.open_account_information.mobile_number
        );
        setCustomerType(response.data.open_account_information.account_type);

        //Personal information
        setProfilePic(response.data.personal_information.profile_picture_file);
        setAccountType(response.data.personal_information.account_type);
        setFullName(response.data.personal_information.full_name);
        setFormerNames(response.data.personal_information.former_names);
        const date = new Date(response.data.personal_information.date_of_birth);
        const formattedDate = date.toLocaleDateString("en-GB");
        setDob(formattedDate);
        setRedAddress(
          response.data.personal_information.address.google_address
        );
        setApplicantCountryText(
          response.data.personal_information.applicant_country.name
        );
        setSocialSecurityNumber(
          response.data.personal_information.social_security_number
        );
        setApplicantCountry(
          response.data.personal_information.applicant_country.id
        );
        setClientNo(response.data.personal_information.client_id);
        setExpectedAmount(
          response.data.personal_information.expected_investment_amount
        );
        setInvestmentCurrency(
          response.data.personal_information.default_currency
        );
        if (
          response.data.personal_information.account_type.id != 1 &&
          response.data.personal_information.account_type.id != 5
        ) {
          setJointAccountID(
            response.data.personal_information.joint_account.unique_id
          );
          if (
            response.data.personal_information.joint_account.invitations
              .length > 0
          ) {
            const transformed =
              response.data.personal_information.joint_account.invitations.map(
                (item) => {
                  const apiAddress = item.address;

                  // Safely transform backend address to the structure your component expects
                  const formattedAddress = apiAddress
                    ? {
                        full: apiAddress.google_address || "",
                        street: apiAddress.street_number
                          ? `${apiAddress.street_number} ${
                              apiAddress.street_name || ""
                            }`.trim()
                          : apiAddress.address_line_1 || "",
                        route: apiAddress.address_line_2 || "",
                        city: apiAddress.city?.name || "",
                        state: apiAddress.state?.name || "",
                        country: apiAddress.country?.name || "",
                        zip: apiAddress.postal_code || "",
                      }
                    : {
                        full: "",
                        street: "",
                        route: "",
                        city: "",
                        state: "",
                        country: "",
                        zip: "",
                      };

                  return {
                    firstName: item.invitee_first_name || "",
                    lastName: item.invitee_last_name || "",
                    dob: "", // not provided
                    email: item.invitee_email || "",
                    countryCode: item.invitee_country_code || "AU(+61)",
                    mobile: item.invitee_mobile_number || "",
                    address: formattedAddress,
                    accountType: "individual",
                    errors: {
                      email: "",
                      mobile: "",
                    },
                  };
                }
              );

            setJointAccountMembers(transformed);
            let jointUserSoleSignatory =
              response.data.personal_information.joint_account.invitations.filter(
                (item) => item.proposed_is_sole_signatory == true
              );
            if (jointUserSoleSignatory.length > 0) {
              setJointAccountName(
                jointUserSoleSignatory[0].invitee_first_name +
                  " " +
                  jointUserSoleSignatory[0].invitee_last_name
              );
            } else {
              setJointAccountName("Myself");
            }
          }
          setSignatory(
            response.data.personal_information.is_sole_signatory == true
              ? "yes"
              : "no"
          );
          setFileAttorney(
            response.data.personal_information.power_of_attorney_file
          );
        }
        // Business Info
        setTaxResidentCountry(
          response.data.business_information.tax_resident_country.id
        );
        setTaxResidentCountryText(
          response.data.business_information.tax_resident_country.name
        );
        if (response.data.business_information.tax_resident_country.id == 2) {
          setNonResCountry(response.data.business_information.country.id);
          setNonResCountryText(response.data.business_information.country.name);
        }
        setBusinessAddress(
          response.data.business_information.address.google_address
        );
        setBusinessName(response.data.business_information.business_name);

        if (response.data.business_information.tax_resident_country.id == 1) {
          setAbn(response.data.business_information.abn);
        }
        if (response.data.business_information.tax_resident_country.id != 1) {
          setBusinessNatureText(
            response.data.business_information.business_nature.name
          );
          setBusinessNature(
            response.data.business_information.business_nature.id
          );
          setBusinessRegistrationNumber(
            response.data.business_information.business_registration_number
          );

          setBusinessActivityText(
            response.data.business_information.business_activity.name
          );
          setBusinessActivity(
            response.data.business_information.business_activity.id
          );
          setOtherActivity(
            response.data.business_information.other_business_activity
          );
          setAccountPurpose(
            response.data.business_information.purpose_of_opening_account
          );
          setFilePurpose(response.data.business_information.documents[0]);

          setTransactionNature(
            response.data.business_information
              .nature_n_level_of_intended_transactions
          );
          setFundSource(response.data.business_information.source_of_funds);
          setOwnership(
            response.data.business_information
              .beneficial_ownership_with_caprock == true
              ? "Yes"
              : "No"
          );
          if (response.data.business_information.tax_resident_country.id == 3) {
            setTaxId(response.data.business_information.tax_id);
          }
        }
        //Upload proof
        setImage(response.data.liveness_proof.file);

        // External Bank
        setBankdata(response.data.external_bank);
        //Cash account
        const existingAccount = response.data.cash_account.map((acc) => ({
          value: acc.currency.id,
          label: `${acc.currency.name}`,
        }));
        setAccounts(existingAccount);

        // Upload docs
        setFileThirdParty(response.data.proof_document.contract_files);
        setThirdPartySign(
          response.data.proof_document.has_prosecution_history == true
            ? "yes"
            : "no"
        );
        setDescription(response.data.proof_document.prosecution_description);
        setFileProof(response.data.proof_document.prosecution_file);
        if (response.data.personal_information.applicant_country.id == 14) {
          setphotoId(
            response.data.proof_document.photographic_documents[0].document_type
          );
          setPhotoIdText(
            response.data.proof_document.photographic_documents[0]
              .document_type_name
          );
          setExpiryDate(
            response.data.proof_document.photographic_documents[0].expiry_date.split(
              "T"
            )[0]
          );
          setDocumentNumber(
            response.data.proof_document.photographic_documents[0]
              .document_number
          );
          if (
            response.data.proof_document.photographic_documents[0]
              .document_type != 2
          ) {
            setFilePhotographicId(
              response.data.proof_document.photographic_documents[0].file
            );
          }
          if (
            response.data.proof_document.photographic_documents[0]
              .document_type == 2
          ) {
            setFileDriverLinsenceFront(
              response.data.proof_document.photographic_documents[0].file
            );
            setFileDriverLinsenceBack(
              response.data.proof_document.photographic_documents[0].back_file
            );
          }
        }

        if (response.data.personal_information.applicant_country.id != 14) {
          setphotoIdFirst(
            response.data.proof_document.photographic_documents[0].document_type
          );
          setphotoIdFirstText(
            response.data.proof_document.photographic_documents[0]
              .document_type_name
          );
          if (response.data.proof_document.photographic_documents[1]) {
            setphotoIdSecond(
              response.data.proof_document.photographic_documents[1]
                .document_type
            );
            setphotoIdSecondText(
              response.data.proof_document.photographic_documents[1]
                .document_type_name
            );
            setDocumentNumberSecond(
              response.data.proof_document.photographic_documents[1]
                .document_number
            );
            setExpiryDateSecond(
              response.data.proof_document.photographic_documents[1].expiry_date.split(
                "T"
              )[0]
            );
          }

          setDocumentNumber(
            response.data.proof_document.photographic_documents[0]
              .document_number
          );
          setExpiryDate(
            response.data.proof_document.photographic_documents[0].expiry_date.split(
              "T"
            )[0]
          );

          if (
            response.data.proof_document.photographic_documents[0]
              .document_type != 2
          ) {
            setfilePhotographicIdFirst(
              response.data.proof_document.photographic_documents[0].file
            );
          }
          if (
            response.data.proof_document.photographic_documents[0]
              .document_type == 2
          ) {
            setFileDriverLinsenceFrontFirst(
              response.data.proof_document.photographic_documents[0].file
            );
            setFileDriverLinsenceBackFirst(
              response.data.proof_document.photographic_documents[0].back_file
            );
          }
          if (
            response.data.proof_document.photographic_documents[1] &&
            response.data.proof_document.photographic_documents[1]
              .document_type != 2
          ) {
            setfilePhotographicIdSecond(
              response.data.proof_document.photographic_documents[1].file
            );
          }
          if (
            response.data.proof_document.photographic_documents[1] &&
            response.data.proof_document.photographic_documents[1]
              .document_type == 2
          ) {
            setFileDriverLinsenceFrontSecond(
              response.data.proof_document.photographic_documents[1].file
            );
            setFileDriverLinsenceBackSecond(
              response.data.proof_document.photographic_documents[1].back_file
            );
          }
        }
        setNonPhotoId(response.data.proof_document.non_photogenic_id_type);
        setNonPhotoIdText(
          response.data.proof_document.non_photogenic_id_type_name
        );
        setfileNonPhotographicId(
          response.data.proof_document.non_photogenic_file
        );
        setPersonalDataId(response.data.proof_document.personal_details_type);
        setPersonalDataIdText(
          response.data.proof_document.personal_details_type_name
        );
        if (response.data.proof_document.cv_file) {
          setFileCV(response.data.proof_document.cv_file);
        }
        setWebLink(response.data.proof_document.website_link);
        // setFileThirdParty(response.data.contract_files[0]);
        // setDescription(response.data.prosecution_description);
        // setFileProof(response.data.prosecution_file);
        // setSignatory(
        //   response.data.has_prosecution_history == true ? "yes" : "no"
        // );
        // if (applicantCountry == 14) {
        //   setphotoId(response.data.photographic_documents[0].document_type);
        //   setExpiryDate(
        //     response.data.photographic_documents[0].expiry_date.split("T")[0]
        //   );
        //   setDocumentNumber(
        //     response.data.photographic_documents[0].document_number
        //   );
        //   if (response.data.photographic_documents[0].document_type != 2) {
        //     setFilePhotographicId(response.data.photographic_documents[0].file);
        //   }
        //   if (response.data.photographic_documents[0].document_type == 2) {
        //     setFileDriverLinsenceFront(
        //       response.data.photographic_documents[0].file
        //     );
        //     setFileDriverLinsenceBack(
        //       response.response.data.photographic_documents[0].back_file
        //     );
        //   }
        // }
        // if (applicantCountry != 14) {
        //   setphotoIdFirst(
        //     response.data.photographic_documents[0].document_type
        //   );
        //   setphotoIdSecond(
        //     response.data.photographic_documents[1].document_type
        //   );
        //   setDocumentNumber(
        //     response.data.photographic_documents[0].document_number
        //   );
        //   setExpiryDate(
        //     response.data.photographic_documents[0].expiry_date.split("T")[0]
        //   );
        //   setDocumentNumberSecond(
        //     response.data.photographic_documents[1].document_number
        //   );
        //   setExpiryDateSecond(
        //     response.data.photographic_documents[1].expiry_date.split("T")[0]
        //   );
        //   if (response.data.photographic_documents[0].document_type != 2) {
        //     setfilePhotographicIdFirst(
        //       response.data.photographic_documents[0].file
        //     );
        //   }
        //   if (response.data.photographic_documents[0].document_type == 2) {
        //     setFileDriverLinsenceFrontFirst(
        //       response.data.photographic_documents[0].file
        //     );
        //     setFileDriverLinsenceBackFirst(
        //       response.data.photographic_documents[0].back_file
        //     );
        //   }
        //   if (response.data.photographic_documents[1].document_type != 2) {
        //     setfilePhotographicIdSecond(
        //       response.data.photographic_documents[1].file
        //     );
        //   }
        //   if (response.data.photographic_documents[1].document_type == 2) {
        //     setFileDriverLinsenceFrontSecond(
        //       response.data.photographic_documents[1].file
        //     );
        //     setFileDriverLinsenceBackSecond(
        //       response.data.photographic_documents[1].back_file
        //     );
        //   }
        // }
        // setNonphotoId(response.data.non_photogenic_id_type);
        // setNonphotoIdText(response.data.non_photogenic_id_type_name);
        // setpreselectedNonPhotoId({
        //   value: response.data.non_photogenic_id_type,
        //   label: response.data.non_photogenic_id_type_name,
        // });
        // setfileNonPhotographicId(response.data.non_photogenic_file);
        // setPersonalDataId(response.data.personal_details_type);
        // setPersonalDataIdText(response.data.personal_details_type_name);
        // setpreselectedPersonal({
        //   value: response.data.personal_details_type,
        //   label: response.data.personal_details_type_name,
        // });
        // if (response.data.cv_file) {
        //   setFileCV(response.data.cv_file);
        // }
        // setWebLink(response.data.website_link);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getDetailsInvitee = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/advisor/onboarding/verification/customer/${customerId}/invitee/preview/verifications`
      );

      if (response.status == 200) {
        //SignUp details
        setFirstName(response.data.open_account_information.first_name);
        setLastName(response.data.open_account_information.last_name);
        setEmail(response.data.open_account_information.email_address);
        setMobileNumber(
          response.data.open_account_information.country_code +
            response.data.open_account_information.mobile_number
        );
        setCustomerType(response.data.open_account_information.account_type);

        //Personal information
        setProfilePic(response.data.personal_information.profile_picture_file);
        setAccountType(response.data.personal_information.account_type);
        setFullName(response.data.personal_information.full_name);
        setFormerNames(response.data.personal_information.former_names);
        const date = new Date(response.data.personal_information.date_of_birth);
        const formattedDate = date.toLocaleDateString("en-GB");
        setDob(formattedDate);
        setRedAddress(
          response.data.personal_information.address.google_address
        );
        setApplicantCountryText(
          response.data.personal_information.applicant_country.name
        );
        setSocialSecurityNumber(
          response.data.personal_information.social_security_number
        );
        setApplicantCountry(
          response.data.personal_information.applicant_country.id
        );
        setClientNo(response.data.personal_information.client_id);
        setExpectedAmount(
          response.data.personal_information.expected_investment_amount
        );
        setInvestmentCurrency(
          response.data.personal_information.default_currency
        );
        //Upload proof
        setImage(response.data.liveness_proof.file);

        // Upload docs
        setFileThirdParty(response.data.proof_document.contract_files);
        setThirdPartySign(
          response.data.proof_document.has_prosecution_history == true
            ? "yes"
            : "no"
        );
        setDescription(response.data.proof_document.prosecution_description);
        setFileProof(response.data.proof_document.prosecution_file);
        if (response.data.personal_information.applicant_country.id == 14) {
          setphotoId(
            response.data.proof_document.photographic_documents[0].document_type
          );
          setPhotoIdText(
            response.data.proof_document.photographic_documents[0]
              .document_type_name
          );
          setExpiryDate(
            response.data.proof_document.photographic_documents[0].expiry_date.split(
              "T"
            )[0]
          );
          setDocumentNumber(
            response.data.proof_document.photographic_documents[0]
              .document_number
          );
          if (
            response.data.proof_document.photographic_documents[0]
              .document_type != 2
          ) {
            setFilePhotographicId(
              response.data.proof_document.photographic_documents[0].file
            );
          }
          if (
            response.data.proof_document.photographic_documents[0]
              .document_type == 2
          ) {
            setFileDriverLinsenceFront(
              response.data.proof_document.photographic_documents[0].file
            );
            setFileDriverLinsenceBack(
              response.data.proof_document.photographic_documents[0].back_file
            );
          }
        }

        if (response.data.personal_information.applicant_country.id != 14) {
          setphotoIdFirst(
            response.data.proof_document.photographic_documents[0].document_type
          );
          setphotoIdFirstText(
            response.data.proof_document.photographic_documents[0]
              .document_type_name
          );
          if (response.data.proof_document.photographic_documents[1]) {
            setphotoIdSecond(
              response.data.proof_document.photographic_documents[1]
                .document_type
            );
            setphotoIdSecondText(
              response.data.proof_document.photographic_documents[1]
                .document_type_name
            );
            setDocumentNumberSecond(
              response.data.proof_document.photographic_documents[1]
                .document_number
            );
            setExpiryDateSecond(
              response.data.proof_document.photographic_documents[1].expiry_date.split(
                "T"
              )[0]
            );
          }

          setDocumentNumber(
            response.data.proof_document.photographic_documents[0]
              .document_number
          );
          setExpiryDate(
            response.data.proof_document.photographic_documents[0].expiry_date.split(
              "T"
            )[0]
          );

          if (
            response.data.proof_document.photographic_documents[0]
              .document_type != 2
          ) {
            setfilePhotographicIdFirst(
              response.data.proof_document.photographic_documents[0].file
            );
          }
          if (
            response.data.proof_document.photographic_documents[0]
              .document_type == 2
          ) {
            setFileDriverLinsenceFrontFirst(
              response.data.proof_document.photographic_documents[0].file
            );
            setFileDriverLinsenceBackFirst(
              response.data.proof_document.photographic_documents[0].back_file
            );
          }
          if (
            response.data.proof_document.photographic_documents[1] &&
            response.data.proof_document.photographic_documents[1]
              .document_type != 2
          ) {
            setfilePhotographicIdSecond(
              response.data.proof_document.photographic_documents[1].file
            );
          }
          if (
            response.data.proof_document.photographic_documents[1] &&
            response.data.proof_document.photographic_documents[1]
              .document_type == 2
          ) {
            setFileDriverLinsenceFrontSecond(
              response.data.proof_document.photographic_documents[1].file
            );
            setFileDriverLinsenceBackSecond(
              response.data.proof_document.photographic_documents[1].back_file
            );
          }
        }
        setNonPhotoId(response.data.proof_document.non_photogenic_id_type);
        setNonPhotoIdText(
          response.data.proof_document.non_photogenic_id_type_name
        );
        setfileNonPhotographicId(
          response.data.proof_document.non_photogenic_file
        );
        setPersonalDataId(response.data.proof_document.personal_details_type);
        setPersonalDataIdText(
          response.data.proof_document.personal_details_type_name
        );
        if (response.data.proof_document.cv_file) {
          setFileCV(response.data.proof_document.cv_file);
        }
        setWebLink(response.data.proof_document.website_link);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const submitApplicationAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = isInvitee
      ? `${BASE_URL}/v1/advisor/onboarding/verification/customer/${customerId}/invitee/submit`
      : `${BASE_URL}/v1/advisor/onboarding/verification/customer/${customerId}/submit`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleSubmit = async () => {
    let toastMessage = null;
    try {
      const response = await submitApplicationAPI();
      if (response.status == 200) {
        toastMessage = {
          message:
            "Application Form has been Submitted Successfully. Caprock team will evaluate your application and get back to you shortly.",
          type: "success",
        };
        navigate("/customer-list");
      } else {
        toastMessage = { message: response.message, type: "error" };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const withdrawApplicationAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/v1/advisor/onboarding/customer/${customerId}/withdraw`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleWithdraw = async () => {
    let toastMessage = null;
    try {
      const response = await withdrawApplicationAPI();
      if (response.status == 200) {
        setIsConfirmWithdraw(false);
        navigate("/login");
      } else {
        toastMessage = { message: response.message, type: "error" };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  useEffect(() => {
    if (!isInvitee) {
      getDetails();
    }
    if (isInvitee) {
      getDetailsInvitee();
    }
  }, []);
  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] lg:min-w-[80vw] lg:max-w-[80vw]">
      <div className="flex-grow overflow-visible">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        {((!isInvitee &&
          stepStatus.length > 0 &&
          (stepStatus[6].status == "IN_REVIEW" ||
            stepStatus[6].status == "COMPLETED")) ||
          (isInvitee &&
            stepStatus.length > 0 &&
            (stepStatus[3].status == "IN_REVIEW" ||
              stepStatus[3].status == "COMPLETED"))) && (
          <div className="mb-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
            <img
              src="/warning-circle.svg"
              alt="Info"
              className="w-4 h-4 mr-2"
            />
            <span>
              Your application is{" "}
              <strong>in review by our onboarding team</strong>. You will be
              notified once the verification is complete.{" "}
            </span>
          </div>
        )}
        <div className="bg-white shadow-md rounded-md p-4">
          <div className="border-b border-colour-custom pb-2">
            <div className="flex items-center space-x-2 mb-2">
              <img src="/note-2.svg" alt="User Avatar" className="h-6 w-6" />
              <h1 className="text-xl font-medium">
                Review And submit your information
              </h1>
            </div>
          </div>
          <div className="bg-white border rounded-md p-4 mt-2">
            <div className="flex items-center border-colour-custom space-x-2 px-4">
              <img
                src="/profile-circle-black.svg"
                alt="User Avatar"
                className="h-6 w-6 mb-2"
              />
              <h1 className="text-xl font-medium mb-2">
                Open Account Information
              </h1>
            </div>

            <div className="bg-white">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                <div className="flex flex-col px-4 pt-4">
                  <label
                    htmlFor="firstName"
                    className="mb-1 text-sm text-labelColour"
                  >
                    First Name
                  </label>
                  <span>{firstName}</span>
                  <label
                    htmlFor="firstName"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Last Name
                  </label>
                  <span>{lastName}</span>
                </div>
                <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                  <label
                    htmlFor="email"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Email
                  </label>
                  <span>{email}</span>
                  <label
                    htmlFor="firstName"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Mobile Number
                  </label>
                  <span>{mobileNumber}</span>
                </div>
                <div className="flex lg:pt-4 pt-0 flex-col px-4">
                  <label
                    htmlFor="customerType"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Customer Type
                  </label>
                  <span>{customerType}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white border rounded-md p-4 mt-4">
            <div className="flex justify-between items-start border-colour-custom px-4">
              {/* Left Section: Icon + Heading */}
              <div className="flex items-center space-x-2">
                <img
                  src="/profile-circle-black.svg"
                  alt="User Avatar"
                  className="h-6 w-6"
                />
                <h1 className="text-xl font-medium">Personal Information</h1>
              </div>

              {/* Right Section: Edit Button */}
              <img
                onClick={(e) => {
                  e.preventDefault();
                  setCurrentStep(1);
                }}
                src="/edit-details.svg"
                alt="Edit Icon"
                className="w-4 h-4 cursor-pointer"
              />
            </div>
            <div className="bg-white border-b pb-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                <div className="flex flex-col px-4 pt-4">
                  <label
                    htmlFor="firstName"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Profile Picture
                  </label>
                  <div className="relative flex-shrink-0 mb-4 lg:mb-0 mt-1 mr-6">
                    <img
                      src={profilePic.presigned_url}
                      alt={`${firstName}`}
                      className="w-20 h-20 rounded-full object-cover"
                    />
                  </div>
                  {/* <label
                    htmlFor="advisorRefNumber"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Advisor Ref No
                  </label>
                  <span>{advisorRefNumber}</span> */}
                  <label
                    htmlFor="TypeOfCustomer"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Type Of Individual Customer
                  </label>
                  <span>{accountType ? accountType.name : ""}</span>
                  {applicantCountry == 233 && (
                    <>
                      <label
                        htmlFor="TypeOfCustomer"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        Social Security Number
                      </label>
                      <span>{socialSecurityNumber}</span>
                    </>
                  )}
                </div>
                <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                  <label
                    htmlFor="fullName"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Full Name
                  </label>
                  <span>{fullName}</span>
                  <label
                    htmlFor="formerNames"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Customer's Former Name(s)
                  </label>
                  <span>{formerNames}</span>
                  <label
                    htmlFor="dob"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Date of Birth
                  </label>
                  <span>{dob}</span>
                  <label
                    htmlFor="redAddress"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Residential Address
                  </label>
                  <span>{redAddress}</span>
                  <label
                    htmlFor="redAddress"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Applicant's Country
                  </label>
                  <span>{applicantCountryText}</span>
                </div>
                <div className="flex lg:pt-4 pt-0 flex-col pr-4">
                  <label
                    htmlFor="clientNo"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Client No
                  </label>
                  <span>{clientNo}</span>
                  <label
                    htmlFor="expectedAmount"
                    className="mt-4 mb-1 text-sm text-labelColour"
                  >
                    Expected Investment Amount
                  </label>
                  <span>{expectedAmount}</span>
                  <label
                    htmlFor="expectedAmount"
                    className="mt-4 mb-1 text-sm text-labelColour"
                  >
                    Default Investment Currency
                  </label>
                  <span>{investmentCurrency.name}</span>
                  {accountType &&
                    accountType.id != 1 &&
                    accountType.id != 5 && (
                      <>
                        <label
                          htmlFor="jointAccountID"
                          className="mt-4 mb-1 text-sm text-labelColour"
                        >
                          Joint Account ID
                        </label>
                        <span>{jointAccountID}</span>
                      </>
                    )}
                </div>
              </div>
            </div>
            {!isInvitee &&
              accountType &&
              accountType.id != 1 &&
              accountType.id != 5 && (
                <div className="bg-white mt-4">
                  <div className="flex items-center border-b border-colour-custom space-x-2 px-4">
                    <h1 className="text-xl font-medium mb-2">
                      Joint Account Members
                    </h1>
                  </div>
                  <div className="overflow-x-auto border-b mb-4">
                    <table className="table-auto w-full h-full border-separate pb-4 pt-4 border-[#EDEDED]  border-spacing-y-2 ">
                      {/* Table Header */}
                      <thead className="text-[#8C8C8C]  rounded-md mb-2 text-sm">
                        {accountType && accountType.id != 4 && (
                          <tr className="border border-[#EDEDED]">
                            {secondheaders.map((header, index) => (
                              <th
                                key={header}
                                className={`
                            cursor-pointer font-medium px-4 py-2 mb-5  text-left
                                        ${index === 0 ? "w-[50px]" : "w-auto"}

                            ${
                              index === 0
                                ? "border-t rounded-tl-md rounded-bl-md border-b border-l border-[#EDEDED]" // Center column: Top and Bottom border only
                                : ""
                            }
                                ${
                                  index === 1 ||
                                  index === 2 ||
                                  index === 3 ||
                                  index === 4 ||
                                  index === 5 ||
                                  index === 6
                                    ? "border-t border-b  border-[#EDEDED]" // Center column: Top and Bottom border only
                                    : ""
                                }
                              ${
                                index === 7
                                  ? "border-t border-b rounded-tr-md rounded-br-md border-r  border-[#EDEDED]" // Center column: Top and Bottom border only
                                  : ""
                              }
                          `}
                              >
                                <div class="flex items-center">
                                  <span>{header}</span>
                                </div>
                              </th>
                            ))}
                          </tr>
                        )}
                        {accountType && accountType.id == 4 && (
                          <tr className="border border-[#EDEDED]">
                            {secondheadersWithAddress.map((header, index) => (
                              <th
                                key={header}
                                className={`
                            cursor-pointer font-medium px-4 py-2 mb-5  text-left
                                        ${index === 0 ? "w-[50px]" : "w-auto"}

                            ${
                              index === 0
                                ? "border-t rounded-tl-md rounded-bl-md border-b border-l border-[#EDEDED]" // Center column: Top and Bottom border only
                                : ""
                            }
                                ${
                                  index === 1 ||
                                  index === 2 ||
                                  index === 3 ||
                                  index === 4 ||
                                  index === 5 ||
                                  index === 6
                                    ? "border-t border-b  border-[#EDEDED]" // Center column: Top and Bottom border only
                                    : ""
                                }
                              ${
                                index === 7
                                  ? "border-t border-b rounded-tr-md rounded-br-md border-r  border-[#EDEDED]" // Center column: Top and Bottom border only
                                  : ""
                              }
                          `}
                              >
                                <div class="flex items-center">
                                  <span>{header}</span>
                                </div>
                              </th>
                            ))}
                          </tr>
                        )}
                      </thead>

                      {/* Table Body */}
                      <tbody className="text-sm mt-6  font-medium text-black">
                        {jointAccountMembers.length > 0 ? (
                          jointAccountMembers.map((member, idx) => (
                            <tr key={idx} className="mb-2 bg-[#F9F9F9]">
                              <td className="px-4 py-4 w-1 text-ellipsis  overflow-hidden whitespace-nowrap">
                                {(idx + 1).toString().padStart(2, "0")}.
                              </td>
                              <td className="px-4 py-4 text-ellipsis  overflow-hidden whitespace-nowrap">
                                {member.firstName}
                              </td>
                              <td className="px-4 py-4 text-ellipsis  overflow-hidden whitespace-nowrap">
                                {member.lastName}
                              </td>
                              <td className="px-4 py-4 text-ellipsis  overflow-hidden whitespace-nowrap">
                                {member.dob}
                              </td>
                              <td className="px-4 py-4 text-ellipsis  overflow-hidden whitespace-nowrap">
                                {member.email}
                              </td>
                              <td className="px-4 py-4 text-left text-ellipsis  overflow-hidden whitespace-nowrap">
                                <span className="text-[#888888]">
                                  {member.countryCode}{" "}
                                </span>
                                {member.mobile}
                              </td>
                              {accountType.id == 4 && (
                                <td className="px-4 py-4 text-ellipsis  overflow-hidden whitespace-nowrap">
                                  {member.address.full}
                                </td>
                              )}
                              <td className="px-4 py-4 text-ellipsis  overflow-hidden whitespace-nowrap">
                                {member.accountType == "individual"
                                  ? "Individual"
                                  : "Corporate"}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td className="text-center py-4" colSpan="7">
                              No results found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="mt-4 border-t grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                    <div className="flex flex-col px-2 md:pl-4 md:pr-0 pt-4">
                      {/* Label and Question */}
                      <div className="flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                        <label
                          htmlFor="investmentType"
                          className="block text-sm text-labelColour whitespace-normal break-words"
                        >
                          Is there going to be a Sole Signatory by providing a
                          Power Of Attorney?
                        </label>

                        {/* Radio Buttons */}
                        <div className="flex items-center gap-4 opacity-50 ">
                          <label className="flex items-center text-sm text-black">
                            <input
                              type="radio"
                              name="signatory"
                              value="yes"
                              disabled={true}
                              checked={signatory === "yes"}
                              className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                            />
                            <span className="ml-2">Yes</span>
                          </label>

                          <label className="flex items-center text-sm text-black">
                            <input
                              type="radio"
                              name="signatory"
                              value="no"
                              disabled={true}
                              checked={signatory === "no"}
                              className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                            />
                            <span className="ml-2">No</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    {signatory == "yes" && (
                      <>
                        <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-2">
                          <div className="flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                            <label
                              htmlFor="jointAccountName"
                              className="mb-1 text-sm text-labelColour whitespace-normal break-words block"
                            >
                              Select which joint account members are going to be
                              the signatories
                            </label>
                            <span>{jointAccountName}</span>
                          </div>
                        </div>
                        <div className="flex lg:pt-4 pt-0 flex-col px-2">
                          <div className="flex items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-labelColour flex items-center"
                            >
                              Power of Attorney
                            </label>
                          </div>
                          {fileAttorney && (
                            <div
                              onClick={(e) => {
                                e.preventDefault();
                                handleFileClick(fileAttorney);
                              }}
                              className="cursor-pointer mt-2 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                            >
                              <div className="flex-col flex">
                                <span className="text-black underline">
                                  {fileAttorney.file_name}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}
          </div>
          {isModalOpen && currentDocument && (
            <DocumentPreview
              fileUrl={currentDocument.presigned_url}
              fileName={currentDocument.file_name}
              onClose={() => setIsModalOpen(false)}
            />
          )}
          {!isInvitee && (
            <div className="bg-white border rounded-md p-4 mt-4">
              <div className="flex justify-between items-start border-colour-custom px-4">
                {/* Left Section: Icon + Heading */}
                <div className="flex items-center space-x-2">
                  <img
                    src="/buildings.svg"
                    alt="User Avatar"
                    className="h-6 w-6"
                  />
                  <h1 className="text-xl font-medium">Business Information</h1>
                </div>

                {/* Right Section: Edit Button */}
                <img
                  onClick={(e) => {
                    e.preventDefault();
                    setCurrentStep(2);
                  }}
                  src="/edit-details.svg"
                  alt="Edit Icon"
                  className="w-4 h-4 cursor-pointer"
                />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                <div className="flex flex-col px-4 pt-4">
                  <label
                    htmlFor="applicantCountry"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Tax Resident Country
                  </label>
                  <span>{taxResidentCountryText}</span>
                  {taxResidentCountry == 2 && (
                    <>
                      <label
                        htmlFor="country"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        Country
                      </label>
                      <span>{nonResCountryText}</span>
                    </>
                  )}

                  {taxResidentCountry != 1 && (
                    <>
                      <label
                        htmlFor="businessNature"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        Business Nature
                      </label>
                      <span>{businessNatureText}</span>
                      <label
                        htmlFor="country"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        Business Registration Number
                      </label>
                      <span>{businessRegistrationNumber}</span>
                    </>
                  )}
                  {taxResidentCountry == 3 && (
                    <>
                      <label
                        htmlFor="country"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        Tax ID
                      </label>
                      <span>{taxId}</span>
                    </>
                  )}
                  {taxResidentCountry == 1 && (
                    <>
                      <label
                        htmlFor="abn"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        ABN
                      </label>
                      <span>{abn}</span>
                    </>
                  )}
                </div>
                <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                  <label
                    htmlFor="businessName"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Business Name
                  </label>
                  <span>{businessName}</span>
                  {taxResidentCountry != 1 && (
                    <>
                      <label
                        htmlFor="businessAddress"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        Describe the business activity
                      </label>
                      <span>{businessActivityText}</span>
                      {businessActivity == 6 && (
                        <>
                          <label
                            htmlFor="businessAddress"
                            className="mb-1 mt-4 text-sm text-labelColour"
                          >
                            Please mention business activity
                          </label>
                          <span>{otherActivity}</span>
                        </>
                      )}
                      <label
                        htmlFor="businessAddress"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        Source of the funds including its origin
                      </label>
                      <span>{fundSource}</span>
                      <label
                        htmlFor="businessAddress"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        Purpose of opening caprock account
                      </label>
                      <span>{accountPurpose}</span>
                      <div className="flex items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm mt-4 text-labelColour flex items-center"
                        >
                          Additional documents
                        </label>
                      </div>
                      {filePurpose && (
                        <div
                          onClick={(e) => {
                            e.preventDefault();
                            handleFileClick(filePurpose);
                          }}
                          className="cursor-pointer mt-2 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                        >
                          <div className="flex-col flex">
                            <span className="text-black underline">
                              {filePurpose.file_name}
                            </span>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
                <div className="flex lg:pt-4 pt-0 flex-col pr-4">
                  <>
                    <label
                      htmlFor="businessAddress"
                      className="mb-1  text-sm text-labelColour"
                    >
                      Address of Principal Place of Business
                    </label>
                    <span>{businessAddress}</span>
                    {taxResidentCountry != 1 && (
                      <>
                        <label
                          htmlFor="applicantCountry"
                          className="mb-1 mt-4 text-sm text-labelColour break-words"
                        >
                          Nature and level of the intended transaction behaviour
                        </label>
                        <span>{transactionNature}</span>
                        <label
                          htmlFor="applicantCountry"
                          className="mb-1 mt-4 text-sm text-labelColour"
                        >
                          Beneficial ownership of the funds used by this account
                          with Caprock
                        </label>
                        <span>{ownership}</span>
                      </>
                    )}
                  </>
                </div>
              </div>
            </div>
          )}
          <div className="bg-white border rounded-md p-4 mt-4">
            <div className="flex justify-between items-start border-colour-custom px-4">
              {/* Left Section: Icon + Heading */}
              <div className="flex items-center space-x-2">
                <img src="/camera.svg" alt="User Avatar" className="h-6 w-6" />
                <h1 className="text-xl font-medium">Prove Its You</h1>
              </div>

              {/* Right Section: Edit Button */}
              <img
                onClick={(e) => {
                  e.preventDefault();
                  setCurrentStep(3);
                }}
                src="/edit-details.svg"
                alt="Edit Icon"
                className="w-4 h-4 cursor-pointer"
              />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              <div className="flex flex-col px-4">
                <div>
                  <span className="text-sm text-[#A6A6A6]">Photo Upload</span>

                  {image && image.presigned_url && (
                    <div className="mt-2 relative w-full max-w-[240px] h-40  rounded-md overflow-hidden">
                      {/* Uploaded Image */}
                      <img
                        src={image.presigned_url}
                        alt="Uploaded"
                        className="w-full h-full object-cover"
                      />

                      {/* Fullscreen Button */}
                      <button
                        onClick={() => setFullscreen(true)}
                        className="absolute top-2 right-2 "
                      >
                        <img
                          src="/show-full.svg"
                          alt="Full Screen"
                          className="w-5 h-5 text-white"
                        />
                      </button>
                    </div>
                  )}
                </div>
              </div>
              {fullscreen && (
                <div
                  className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4 py-6"
                  onClick={() => setFullscreen(false)}
                >
                  <img
                    src={image.presigned_url}
                    alt="Fullscreen"
                    className="max-w-full max-h-full object-contain rounded-md shadow-lg"
                  />
                </div>
              )}
            </div>
          </div>
          {!isInvitee && (
            <div className="bg-white border rounded-md p-4 mt-4">
              <div className="flex justify-between items-start border-colour-custom px-4 mb-2">
                {/* Left Section: Icon + Heading */}
                <div className="flex items-center space-x-2">
                  <img src="/cards.svg" alt="User Avatar" className="h-6 w-6" />
                  <h1 className="text-xl font-medium">
                    Connect External Bank Account
                  </h1>
                </div>

                {/* Right Section: Edit Button */}
                <img
                  onClick={(e) => {
                    e.preventDefault();
                    setCurrentStep(4);
                  }}
                  src="/edit-details.svg"
                  alt="Edit Icon"
                  className="w-4 h-4 cursor-pointer"
                />
              </div>
              {bankdata.map((bank, index) => (
                <div className="relative flex flex-col lg:flex-row items-start lg:items-center lg:space-x-6 mb-6 border rounded-md">
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full pr-6">
                    {/* Column 1 */}
                    <div className="flex flex-col md:px-4 md:pt-6">
                      <label
                        htmlFor="refId"
                        className="mb-1 text-xs text-labelColour"
                      >
                        {index + 1}. Account Holder Name
                      </label>
                      <span className="text-sm">{bank.account_name}</span>
                      <div className="mt-4">
                        <label
                          htmlFor="investmentType"
                          className="mb-1 text-xs text-labelColour"
                        >
                          Account Number or IBAN
                        </label>
                        <div className="text-sm">{bank.account_number}</div>
                      </div>
                      <label
                        htmlFor="investmentManagerFees"
                        className="mb-1 mt-4 text-xs"
                      >
                        <span className="text-labelColour">Swift Code</span>
                      </label>
                      <div className="text-sm">{bank.swift_code}</div>
                      <div className="flex flex-row gap-2 mt-2 mb-2">
                        {bank.isVerified && (
                          <>
                            <button className="bg-white border-[#75E380] border-2 text-[#75E380] text-xs px-2 py-1 rounded-full flex items-center gap-2">
                              <img
                                src="/valid.svg"
                                alt="Camera Icon"
                                className="w-4 h-4"
                              />
                              Verified
                            </button>
                          </>
                        )}
                        {bank.status == "onboarding" && (
                          <>
                            <button className="bg-white border-[#FF5050] border-2 text-[#FF5050] text-xs px-2 py-1 rounded-full flex items-center gap-2">
                              <img
                                src="/danger.svg"
                                alt="Camera Icon"
                                className="w-4 h-4"
                              />
                              Unverified
                            </button>
                          </>
                        )}
                      </div>
                    </div>

                    {/* Column 2 */}
                    <div className="flex pb-4 flex-col md:px-4 md:pt-6 md:border-l">
                      <label
                        htmlFor="investmentManagerFees"
                        className="mb-1 text-xs text-labelColour"
                      >
                        Branch Identifier{" "}
                      </label>
                      <span className="text-sm">
                        {bank.branch_identifier.name}
                      </span>
                      {bank.branch_identifier.id == 1 && (
                        <>
                          <label
                            htmlFor="investmentManagerFees"
                            className="mb-1  mt-4  text-xs text-labelColour"
                          >
                            BSB
                          </label>
                          <span className="text-sm">{bank.account_bsb}</span>
                        </>
                      )}
                      {bank.branch_identifier.id == 2 && (
                        <>
                          <label
                            htmlFor="investmentManagerFees"
                            className="mb-1 mt-4 text-xs text-labelColour"
                          >
                            Country{" "}
                          </label>
                          <span className="text-sm">{bank.country_code}</span>
                          {bank.country_code == "CA" && (
                            <>
                              {" "}
                              <label
                                htmlFor="investmentManagerFees"
                                className="mb-1 mt-4 text-xs text-labelColour"
                              >
                                Financial Institution Identifier{" "}
                              </label>
                              <span className="text-sm">
                                {bank.institution_number}
                              </span>
                              <label
                                htmlFor="investmentManagerFees"
                                className="mb-1 mt-4 text-xs text-labelColour"
                              >
                                Transit Number
                              </label>
                              <span className="text-sm">
                                {bank.transit_number}
                              </span>
                            </>
                          )}
                        </>
                      )}
                      {bank.branch_identifier.id == 3 && (
                        <>
                          <label
                            htmlFor="investmentManagerFees"
                            className="mb-1 mt-4 text-xs text-labelColour"
                          >
                            Routing Number{" "}
                          </label>
                          <span className="text-sm">{bank.routing_number}</span>
                        </>
                      )}
                      <label
                        htmlFor="investmentManagerFees"
                        className="mb-1 mt-4 text-xs text-labelColour"
                      >
                        Active{" "}
                      </label>
                      <span className="text-sm">
                        {bank.is_active == true ? "Yes" : "No"}
                      </span>
                      <label
                        htmlFor="investmentManagerFees"
                        className="mb-1 mt-4 text-xs text-labelColour"
                      >
                        Default{" "}
                      </label>
                      <span className="text-sm">
                        {bank.is_default == true ? "Yes" : "No"}
                      </span>
                      {/* <label
                          htmlFor="investmentManagerFees"
                          className="mb-1 mt-4 text-xs text-labelColour"
                        >
                          Payment Method{" "}
                        </label>
                        <span className="text-sm">{bank.paymentMethod}</span>
                        <label
                          htmlFor="investmentManagerFees"
                          className="mb-1 mt-4 text-xs text-labelColour"
                        >
                          ACH Code{" "}
                        </label>
                        <span className="text-sm">{bank.achCode}</span> */}
                    </div>

                    {/* Column 3 */}
                    <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                      <label
                        htmlFor="investmentManagerFees"
                        className="mb-1 text-xs"
                      >
                        <span className="text-labelColour">Currency</span>
                      </label>
                      <div className="text-sm">{bank.currency.name}</div>
                      <div className="mb-2 mt-4">
                        <label
                          htmlFor="investmentType"
                          className="mb-1 text-xs text-labelColour"
                        >
                          Uploaded Docs
                        </label>
                        {bank.proof_image && (
                          <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                            <div
                              onClick={(e) => {
                                e.preventDefault();
                                handleFileClick(bank.proof_image);
                              }}
                              className="flex-col flex "
                            >
                              <span className="text-black break-all cursor-pointer underline">
                                {bank.proof_image.file_name}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                      <div className="">
                        <label
                          htmlFor="investmentType"
                          className="mb-1 text-xs text-labelColour"
                        >
                          Address
                        </label>
                        <div className="text-sm">
                          {bank.address_line1 != null ? bank.address_line1 : ""}
                        </div>
                        <div className="text-sm">
                          {bank.address_line2 != null ? bank.address_line2 : ""}
                        </div>
                        <div className="text-sm">
                          {bank.address_line3 != null ? bank.address_line3 : ""}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
          {!isInvitee && (
            <div className="bg-white border rounded-md p-4 mt-4">
              <div className="flex flex-col md:flex-row md:items-center justify-between border-colour-custom px-4 py-2 gap-2">
                {/* Left Section */}
                <div className="flex items-center space-x-2">
                  <img src="/money-2.svg" alt="Cash Icon" className="h-6 w-6" />
                  <h1 className="text-xl font-medium">
                    Cash Account Information
                  </h1>
                </div>

                {/* Right Section - Responsive */}
                <div className="flex items-center justify-start md:justify-end gap-x-2 flex-wrap">
                  <div className="flex flex-col items-start md:items-end">
                    <span className="text-sm font-semibold text-[#464646] leading-tight">
                      No. Of Cash Account
                    </span>
                  </div>
                  <span className="text-md font-semibold hidden md:inline">
                    |
                  </span>
                  <span className="text-sm font-semibold rounded-md text-white py-1 px-3 bg-[#34C046]">
                    {String(accounts.length).padStart(2, "0")}
                  </span>
                  <img
                    onClick={(e) => {
                      e.preventDefault();
                      setCurrentStep(5);
                    }}
                    src="/edit-details.svg"
                    alt="Edit Icon"
                    className="w-4 h-4 cursor-pointer"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {Array.from({ length: accounts.length }).map((_, index) => (
                  <div key={index} className="px-4 py-2">
                    <label
                      htmlFor="advisorRefNumber"
                      className="mb-1 mt-4 text-sm text-labelColour"
                    >
                      Account No.{String(index + 1).padStart(2, "0")}
                    </label>
                    <span className="text-sm">{accounts[index].label}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
          <div className="bg-white border rounded-md p-4 mt-4">
            <div className="flex justify-between items-start border-colour-custom px-4">
              {/* Left Section: Icon + Heading */}
              <div className="flex items-center space-x-2">
                <img src="/note-2.svg" alt="User Avatar" className="h-6 w-6" />
                <h1 className="text-xl font-medium">Upload Proof Documents</h1>
              </div>

              {/* Right Section: Edit Button */}
              <img
                onClick={(e) => {
                  e.preventDefault();
                  setCurrentStep(6);
                }}
                src="/edit-details.svg"
                alt="Edit Icon"
                className="w-4 h-4 cursor-pointer"
              />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 border-b pb-2">
              {/* first column */}
              <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                <div className="flex items-center justify-between">
                  <label
                    htmlFor="investmentType"
                    className="text-sm text-labelColour  whitespace-normal break-words block"
                  >
                    Contracts with third parties to verify the intended
                    transaction
                  </label>
                </div>
                {fileThirdParty && (
                  <div
                    onClick={(e) => {
                      e.preventDefault();
                      handleFileClick(fileThirdParty);
                    }}
                    className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                  >
                    <div className="flex-col flex">
                      <span className="text-black underline">
                        {fileThirdParty.file_name}
                      </span>
                    </div>
                  </div>
                )}
              </div>
              {/* second column */}
              <div className="flex flex-col pr-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                <div className="flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                  <label
                    htmlFor="investmentType"
                    className="labelColour block whitespace-normal break-words text-sm text-labelColour flex items-center"
                  >
                    Details of any current or recent prosecutions and inquiries
                    related to Money Laundering, terrorist links, tax offences
                    and corruption in respect of the Individual
                  </label>

                  {/* Radio Buttons */}
                  <div className="flex items-center gap-4 opacity-50 ">
                    <label className="flex items-center text-sm text-black">
                      <input
                        type="radio"
                        name="thirdPartySign"
                        value="yes"
                        checked={thirdPartySign === "yes"}
                        className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                      />
                      <span className="ml-2">Yes</span>
                    </label>

                    <label className="flex items-center text-sm text-black">
                      <input
                        type="radio"
                        name="thirdPartySign"
                        value="no"
                        checked={thirdPartySign === "no"}
                        className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                      />
                      <span className="ml-2">No</span>
                    </label>
                  </div>
                </div>
                {thirdPartySign === "yes" && (
                  <div className="mt-4">
                    <label
                      htmlFor="description"
                      className="mb-1 text-sm text-labelColour"
                    >
                      Description
                    </label>
                    <span>{description}</span>
                  </div>
                )}
              </div>
              {/* third column */}
              <div className="flex flex-col pr-4 pt-4">
                {thirdPartySign === "yes" && (
                  <>
                    <div className="flex items-center justify-between">
                      <label
                        htmlFor="investmentType"
                        className="text-sm text-labelColour  whitespace-normal break-words block"
                      >
                        Upload Proof
                      </label>
                    </div>
                    {fileProof && (
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          handleFileClick(fileProof);
                        }}
                        className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                      >
                        <div className="flex-col flex">
                          <span className="text-black underline">
                            {fileProof.file_name}
                          </span>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 pt-2">
              {/* first column */}
              <div className="flex flex-col pr-4 sm:border-r-0 md:border-r border-gray-300">
                {applicantCountry == 14 && (
                  <>
                    <div className="flex items-center justify-between">
                      <label
                        htmlFor="investmentType"
                        className="text-sm text-labelColour  whitespace-normal break-words block"
                      >
                        Photographic ID
                      </label>
                    </div>
                    <span>{photoIdText}</span>

                    {(photoId == 1 || photoId == 3) && (
                      <>
                        <div className="flex items-center justify-between">
                          {photoId == 1 && (
                            <label
                              htmlFor="investmentType"
                              className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                            >
                              Upload Certified Copy of Passport
                            </label>
                          )}
                          {photoId == 3 && (
                            <label
                              htmlFor="investmentType"
                              className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                            >
                              Upload Photo ID issued under a State or Territory
                              law
                            </label>
                          )}
                        </div>
                        {photoId == 1 && (
                          <>
                            {" "}
                            <label
                              htmlFor="refId"
                              className="mb-1 mt-4 text-sm text-labelColour"
                            >
                              Passport Number
                            </label>
                            <span>{documentNumber}</span>
                          </>
                        )}
                        {photoId == 3 && (
                          <>
                            {" "}
                            <label
                              htmlFor="refId"
                              className="mb-1 mt-4 text-sm text-labelColour"
                            >
                              Document Number
                            </label>
                            <span>{documentNumber}</span>
                          </>
                        )}
                        {filePhotographicId && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(filePhotographicId);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                          >
                            <div className="flex-col flex">
                              <span className="text-black underline">
                                {filePhotographicId.file_name}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    {photoId == 2 && (
                      <>
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            Upload Certified Copy of Driver's License (Front)
                          </label>
                        </div>
                        <label
                          htmlFor="refId"
                          className="mb-1 mt-4 text-sm text-labelColour"
                        >
                          Driver's License Number
                        </label>
                        <span>{documentNumber}</span>
                        {fileDriverLinsenceFront && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(fileDriverLinsenceFront);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                          >
                            <div className="flex-col flex">
                              <span className="text-black underline">
                                {fileDriverLinsenceFront.file_name}
                              </span>
                            </div>
                          </div>
                        )}
                        <div className="mt-2 flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            Upload Certified Copy of Driver's License (Back)
                          </label>
                        </div>
                        {fileDriverLinsenceBack && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(fileDriverLinsenceBack);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                          >
                            <div className="flex-col flex">
                              <span className="text-black underline">
                                {fileDriverLinsenceBack.file_name}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    <div className="mt-2">
                      <label className="block mb-1 w-full text-sm text-[#464646]">
                        Expiry Date
                      </label>
                      <input
                        type="date"
                        value={expiryDate}
                        disabled={true}
                        className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                      />{" "}
                    </div>
                  </>
                )}
                {applicantCountry != 14 && (
                  <>
                    {/* first photo id */}
                    <div className="">
                      <label
                        htmlFor="firstName"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Select First Photographic ID
                      </label>
                      <span>{photoIdFirstText}</span>
                    </div>
                    {(photoIdFirst == 1 || photoIdFirst == 3) && (
                      <>
                        <div className="flex items-center justify-between">
                          {photoIdFirst == 1 && (
                            <label
                              htmlFor="investmentType"
                              className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                            >
                              Upload Notarised Foreign Government Issued
                              Passport
                            </label>
                          )}
                          {photoIdFirst == 3 && (
                            <label
                              htmlFor="investmentType"
                              className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                            >
                              Upload Photo ID issued under a State or Territory
                              law
                            </label>
                          )}
                        </div>
                        {photoIdFirst == 1 && (
                          <>
                            {" "}
                            <label
                              htmlFor="refId"
                              className="mb-1 mt-4 text-sm text-labelColour"
                            >
                              Passport Number
                            </label>
                            <span>{documentNumber}</span>
                          </>
                        )}
                        {photoIdFirst == 3 && (
                          <>
                            {" "}
                            <label
                              htmlFor="refId"
                              className="mb-1 mt-4 text-sm text-labelColour"
                            >
                              Document Number
                            </label>
                            <span>{documentNumber}</span>
                          </>
                        )}
                        {filePhotographicIdFirst && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(filePhotographicIdFirst);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                          >
                            <div className="flex-col flex">
                              <span className="text-black underline">
                                {filePhotographicIdFirst.file_name}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    {photoIdFirst == 2 && (
                      <>
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            Upload Certified Copy of Driver's License (Front)
                          </label>
                        </div>
                        <label
                          htmlFor="refId"
                          className="mb-1 mt-4 text-sm text-labelColour"
                        >
                          Driver's License Number
                        </label>
                        <span>{documentNumber}</span>
                        {fileDriverLinsenceFrontFirst && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(fileDriverLinsenceFrontFirst);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                          >
                            <div className="flex-col flex">
                              <span className="text-black underline">
                                {fileDriverLinsenceFrontFirst.file_name}
                              </span>
                            </div>
                          </div>
                        )}
                        <div className="mt-2 flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            Upload Certified Copy of Driver's License (Back)
                          </label>
                        </div>
                        {fileDriverLinsenceBackFirst && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(fileDriverLinsenceBackFirst);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                          >
                            <div className="flex-col flex">
                              <span className="text-black underline">
                                {fileDriverLinsenceBackFirst.file_name}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    <div className="mt-2">
                      <label className="block mb-1 w-full text-sm text-[#464646]">
                        Expiry Date
                      </label>
                      <input
                        type="date"
                        value={expiryDate}
                        disabled={true}
                        className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                      />
                    </div>
                    {/* second photo id */}
                    <div className="">
                      <label
                        htmlFor="firstName"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Select Second Photographic ID
                      </label>
                      <span>{photoIdSecondText}</span>
                    </div>
                    {(photoIdSecond == 1 || photoIdSecond == 3) && (
                      <>
                        <div className="flex items-center justify-between">
                          {photoIdSecond == 1 && (
                            <label
                              htmlFor="investmentType"
                              className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                            >
                              Upload Notarised Foreign Government Issued
                              Passport
                            </label>
                          )}
                          {photoIdSecond == 3 && (
                            <label
                              htmlFor="investmentType"
                              className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                            >
                              Upload Photo ID issued under a State or Territory
                              law
                            </label>
                          )}
                        </div>
                        {photoIdSecond == 1 && (
                          <>
                            {" "}
                            <label
                              htmlFor="refId"
                              className="mb-1 mt-4 text-sm text-labelColour"
                            >
                              Passport Number
                            </label>
                            <span>{documentNumberSecond}</span>
                          </>
                        )}
                        {photoIdSecond == 3 && (
                          <>
                            {" "}
                            <label
                              htmlFor="refId"
                              className="mb-1 mt-4 text-sm text-labelColour"
                            >
                              Document Number
                            </label>
                            <span>{documentNumberSecond}</span>
                          </>
                        )}
                        {filePhotographicIdSecond && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(filePhotographicIdSecond);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                          >
                            <div className="flex-col flex">
                              <span className="text-black underline">
                                {filePhotographicIdSecond.file_name}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    {photoIdSecond == 2 && (
                      <>
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            Upload Certified Copy of Driver's License (Front)
                          </label>
                        </div>
                        <label
                          htmlFor="refId"
                          className="mb-1 mt-4 text-sm text-labelColour"
                        >
                          Driver's License Number
                        </label>
                        <span>{documentNumberSecond}</span>

                        {fileDriverLinsenceFrontSecond && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(fileDriverLinsenceFrontSecond);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                          >
                            <div className="flex-col flex">
                              <span className="text-black underline">
                                {fileDriverLinsenceFrontSecond.file_name}
                              </span>
                            </div>
                          </div>
                        )}
                        <div className="mt-2 flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            Upload Certified Copy of Driver's License (Back)
                          </label>
                        </div>
                        {fileDriverLinsenceBackSecond && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(fileDriverLinsenceBackSecond);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                          >
                            <div className="flex-col flex">
                              <span className="text-black underline">
                                {fileDriverLinsenceBackSecond.file_name}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    <div className="mt-2">
                      <label className="block mb-1 w-full text-sm text-[#464646]">
                        Expiry Date
                      </label>
                      <input
                        type="date"
                        value={expiryDateSecond}
                        disabled={true}
                        className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                      />{" "}
                    </div>
                  </>
                )}
              </div>
              {/* second column */}
              <div className="flex flex-col pr-4 sm:border-r-0 md:border-r border-gray-300">
                <label
                  htmlFor="investmentType"
                  className="text-sm text-labelColour  whitespace-normal break-words block"
                >
                  Non Photographic ID
                </label>
                <span>{nonphotoIdText}</span>
                <div className="flex items-center justify-between">
                  <label
                    htmlFor="investmentType"
                    className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                  >
                    Upload Document
                  </label>
                </div>
                {fileNonPhotographicId && (
                  <div
                    onClick={(e) => {
                      e.preventDefault();
                      handleFileClick(fileNonPhotographicId);
                    }}
                    className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                  >
                    <div className="flex-col flex">
                      <span className="text-black underline">
                        {fileNonPhotographicId.file_name}
                      </span>
                    </div>
                  </div>
                )}
              </div>
              {/* third column */}
              <div className="flex flex-col pr-4">
                <div className="">
                  <label
                    htmlFor="investmentType"
                    className="mt-2 text-sm text-[#B2B2B2]  whitespace-normal break-words block"
                  >
                    Personal Details
                  </label>
                </div>
                <span>{personalDataIdText}</span>
                {personalDataId == 1 && (
                  <>
                    <div className="flex mt-2 items-center justify-between">
                      <label
                        htmlFor="investmentType"
                        className="text-sm text-labelColour  whitespace-normal break-words block"
                      >
                        Upload CV
                      </label>
                    </div>
                    {fileCV && (
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          handleFileClick(fileCV);
                        }}
                        className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                      >
                        <div className="flex-col flex underline">
                          <span className="text-black">{fileCV.file_name}</span>
                        </div>
                      </div>
                    )}
                  </>
                )}
                {personalDataId == 2 && (
                  <>
                    <label
                      htmlFor="refId"
                      className="mb-1 mt-4 text-sm text-labelColour"
                    >
                      Website Link
                    </label>
                    <span>{webLink}</span>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer className="bottom-actions flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#005A9C]">
        {((!isInvitee &&
          stepStatus[6] &&
          stepStatus[6].status !== "COMPLETED" &&
          stepStatus[6].status !== "APPROVED" &&
          stepStatus[6].status !== "IN_REVIEW") ||
          (isInvitee &&
            stepStatus[3] &&
            stepStatus[3].status !== "COMPLETED" &&
            stepStatus[3].status !== "APPROVED" &&
            stepStatus[3].status !== "IN_REVIEW")) && (
          <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
            {/* Save as Draft */}
            <button
              onClick={() => {
                setIsConfirmWithdraw(true);
              }}
              className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
            >
              <span>Withdraw Application</span>
            </button>

            <button
              onClick={(e) => {
                e.preventDefault();
                setLoading(true);
                handleSubmit();
              }}
              className="flex bg-white w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-black font-medium py-2 px-4 rounded-full text-sm"
            >
              <span>Submit</span>
            </button>
          </div>
        )}
        {((!isInvitee &&
          stepStatus[6] &&
          (stepStatus[6].status === "COMPLETED" ||
            stepStatus[6].status === "APPROVED" ||
            stepStatus[6].status === "IN_REVIEW")) ||
          (isInvitee &&
            stepStatus[3] &&
            (stepStatus[3].status === "COMPLETED" ||
              stepStatus[3].status === "APPROVED" ||
              stepStatus[3].status === "IN_REVIEW"))) && (
          <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
            {/* Save as Draft */}
            <button
              onClick={() => {
                navigate("/customer-list");
              }}
              className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
            >
              <span>Back</span>
            </button>
          </div>
        )}
      </footer>
      {isConfirmWithdraw && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div class="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
            <button class="absolute top-3 right-3 text-black text-xl font-bold">
              &times;
            </button>

            <div class="flex justify-center items-center mb-4">
              <div class="flex items-center justify-center">
                <img
                  src="/warning-circle.svg"
                  alt="Add Template Icon"
                  className="h-10 w-10"
                />
              </div>
            </div>

            <h2 class="text-lg font-medium mb-2">
              Are you sure you want to Withdraw Application?
            </h2>
            <p class="text-sm text-black mb-4">
              This will delete all details entered during registration. None of
              the details entered in this form will be saved.
            </p>

            <div class="flex justify-center space-x-4">
              <button
                onClick={() => {
                  setIsConfirmWithdraw(false);
                }}
                class="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
              >
                No
              </button>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setLoading(true);
                  handleWithdraw();
                }}
                class="px-6 py-2 bg-black text-white rounded-full font-medium hover:bg-gray-800"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReviewSubmit;
